import { render } from "./NewDocumentsCard.vue?vue&type=template&id=53e50db5&scoped=true"
import script from "./NewDocumentsCard.vue?vue&type=script&lang=js"
export * from "./NewDocumentsCard.vue?vue&type=script&lang=js"

import "./NewDocumentsCard.vue?vue&type=style&index=0&id=53e50db5&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e50db5"]])

export default __exports__